"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var _this = this;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var cache_1 = require("../../cache/cache");

var QueryError_1 = require("../../client/errors/QueryError");

var clientContext_1 = require("../../context/clientContext/clientContext");

var responseReducer_1 = require("../../reducers/responseReducer");

var useCachedResponse_1 = require("../useCachedResponse/useCachedResponse");

exports.useQuery = function (action, initFetch) {
  if (initFetch === void 0) {
    initFetch = true;
  }

  var clientContext = react_1.useContext(clientContext_1.ClientContext);
  var cachedResponse = useCachedResponse_1.useCachedResponse(action);
  var isMounted = react_1.useRef(true);
  var controller = react_1.useRef();

  var _a = react_1.useReducer(responseReducer_1.responseReducer, {
    loading: cachedResponse ? false : initFetch,
    response: cachedResponse ? cachedResponse : {
      error: false
    }
  }),
      state = _a[0],
      dispatch = _a[1];

  react_1.useEffect(function () {
    isMounted.current = true;

    if (initFetch && !cachedResponse) {
      handleQuery();
    }

    return function () {
      isMounted.current = false;
      handleAbort();
    };
  }, [cache_1.convertActionToBase64(action)]);
  var handleQuery = react_1.useCallback(function (skipCache) {
    if (skipCache === void 0) {
      skipCache = false;
    }

    return __awaiter(_this, void 0, void 0, function () {
      var abortController, signal, queryResponse;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            abortController = 'AbortController' in window ? new AbortController() : undefined;
            signal = action.signal || (abortController ? abortController.signal : undefined);

            if (controller.current) {
              controller.current.abort();
            }

            controller.current = abortController;

            if (!isMounted.current) {
              return [2
              /*return*/
              , {
                error: false
              }];
            }

            dispatch({
              type: responseReducer_1.SET_LOADING
            });
            return [4
            /*yield*/
            , clientContext.query(__assign({}, action, {
              signal: action.signal || signal
            }), skipCache)];

          case 1:
            queryResponse = _a.sent();

            if (isMounted.current && !(queryResponse.errorObject && queryResponse.errorObject.name === 'AbortError')) {
              dispatch({
                type: responseReducer_1.SET_RESPONSE,
                response: queryResponse
              });
            }

            if (isMounted.current && queryResponse.errorObject && queryResponse.errorObject.name === 'AbortError' && controller.current && controller.current === abortController) {
              controller.current = undefined;
              dispatch({
                type: responseReducer_1.RESET_LOADING
              });
            }

            return [2
            /*return*/
            , queryResponse];
        }
      });
    });
  }, [cache_1.convertActionToBase64(action)]);
  var handleReload = react_1.useCallback(function () {
    return handleQuery(true);
  }, [cache_1.convertActionToBase64(action)]);
  var handleAbort = react_1.useCallback(function () {
    if (controller.current) {
      controller.current.abort();
    }
  }, []);
  var handleReset = react_1.useCallback(function () {
    dispatch({
      type: responseReducer_1.RESET
    });
  }, []);

  if (state.response && state.response.errorObject && state.response.errorObject instanceof QueryError_1.QueryError) {
    throw state.response.errorObject;
  }

  return __assign({
    abort: handleAbort,
    loading: state.loading,
    query: handleReload,
    reset: handleReset
  }, state.response);
};